import { render, staticRenderFns } from "./mynav.vue?vue&type=template&id=74beee4e&scoped=true&"
import script from "./mynav.vue?vue&type=script&lang=js&"
export * from "./mynav.vue?vue&type=script&lang=js&"
import style0 from "./mynav.vue?vue&type=style&index=0&id=74beee4e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74beee4e",
  null
  
)

export default component.exports